import Link from "next/link";

import { Anchor, Button } from "@newsela/angelou";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import { anchorCss } from "./LearnMoreCta.style";

const LearnMoreCta = () => {
  return (
    <Link href={`${MONOLITH_ORIGIN}/about/solutions`} passHref legacyBehavior>
      <Anchor
        __cssFor={{ root: anchorCss }}
        styleAnchorAsButton={{
          flavor: Button.flavors.secondary,
        }}
      >
        Learn more
      </Anchor>
    </Link>
  );
};

export default LearnMoreCta;
